import { render, staticRenderFns } from "./Dashbord.vue?vue&type=template&id=a20ea18a&"
import script from "./Dashbord.vue?vue&type=script&lang=js&"
export * from "./Dashbord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports